interface ChatToastProps {
    message: string | null
}

export function ChatToast({ message }: ChatToastProps) {
    if (!message) return null

    return (
        <div className="absolute top-3 left-1/2 z-20 -translate-x-1/2 rounded-full bg-slate-900 px-3 py-1 text-xs text-white shadow">
            {message}
        </div>
    )
}
